import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=b5c906c4&scoped=true"
import script from "./FormView.vue?vue&type=script&setup=true&lang=js"
export * from "./FormView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormView.vue?vue&type=style&index=0&id=b5c906c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c906c4",
  null
  
)

export default component.exports